import React from 'react';

function PageInfo(props) {
  return (
    <div>
      <>
        <div className="titles">
          <h3 className='title'>About me</h3>
          <p className='commit'>Brief information about myself. </p>
        </div>
      </>
    </div>
  );
}

export default PageInfo;